var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-autocomplete", {
        staticClass: "inline-input",
        staticStyle: { width: "1.7rem" },
        attrs: {
          slot: "reference",
          "fetch-suggestions": (queryString, cb) => {
            _vm.spotQuerySearch(queryString, cb, _vm.spotItem)
          },
          placeholder: "请选择景点",
          "value-key": "value",
          size: "mini",
        },
        on: {
          select: function ($event) {
            return _vm.spotHandleSelect($event, _vm.spotItem)
          },
        },
        slot: "reference",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(item.nameCn)),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.spotItem.spotName,
          callback: function ($$v) {
            _vm.$set(_vm.spotItem, "spotName", $$v)
          },
          expression: "spotItem.spotName",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }